<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <div class="row">
          <div class="col-3">
            <h2 class="card-title-desc">All Customers</h2>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-3" v-if="isUserStaff()">
            <button v-if="httpLoading" class="btn btn-dark me-1" :disabled="httpLoading">Loading</button>
            <button v-else class="btn btn-info me-1" @click="downloadCustomersReport">Download Customers Report</button>
          </div>
        </div>
        <TableLoading v-if="institutions.page === 0"/>
        <div v-else class="px-4 pb-4">
          <data-table :columns="customersColumns" :rows="institutions.objects" :current-page="currentPage" :has-pagination="false" @onSearch="searchFn">
            <template v-slot:actions="slotProps">
              <div class="button-items">
                <b-button v-if="checkForPermission(view_single_customer_permission)" variant="info" size="sm" class="py-1 text-white" @click="viewCustomerDetails(slotProps.row.publicId)">
                  View Customer
                </b-button>
                <b-button v-if="checkForPermission(edit_customer_profile)" v-b-modal.edit-customer variant="success" size="sm" class="py-1 text-white" @click="selectCustomer(slotProps.row)">
                  Edit Customer
                </b-button>
              </div>
            </template>
          </data-table>
          <b-pagination
              v-model="currentPage"
              :total-rows="institutions.total"
              :per-page="perPage"
              size="lg"
              align="center"
              class="mt-3"
          />
        </div>
      </div>
    </div>
    <b-modal
        id="edit-customer"
        centered
        hide-footer
        hide-header
        size="xl"
        title-class="font-18">
      <div class="p-2">
        <h3>Edit Customer</h3>
        <customer-form :selected_customer="selected_customer" button_text="Edit Customer" @customerAction="updateCustomer"/>
        <b-button class="mt-3 float-end" variant="dark" block @click="$bvModal.hide('edit-customer')">Close</b-button>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import {routeItems} from "@/router/endpoints";
import CustomerForm from "@/components/customers/customer-form";
import DataTable from "@/components/data-table";
import {ALL_CUSTOMERS} from "@/gql/customers";
import {mapActions, mapGetters} from "vuex";
import {errorToast, successToast} from "@/components/successToast";
import TableLoading from "@/components/TableLoading";
import {permissions} from "@/router/permissions";
import {downloadFileConfig} from "@/filters/downloadFileConfig";
import moment from "moment/moment";

export default {
  page: {
    title: "Customers",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, DataTable, CustomerForm, PageHeader, Layout},
  name: "customers",
  data() {
    return {
      title: "Customers",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Customers",
          active: true
        }
      ],
      edit_customer_profile: permissions.edit_customer_profile,
      view_single_customer_permission: permissions.view_single_customer_permission,
      currentPage: 1,
      perPage: 30,
      searchKeyword: "",
      institutions: {
        page: 0,
        objects: []
      },
      selected_customer: {},
      customersColumns: [
        {
          field: 'customerTier',
          label: 'Tier'
        },
        {
          field: 'typeId',
          label: 'Category'
        },
        {
          field: 'institutionCode',
          label: 'Customer Code'
        },
        {
          field: 'name',
          label: 'Customer Name'
        },
        {
          field: 'activeState',
          label: 'Status'
        },
        {
          field: 'actions',
          label: 'Action'
        }
      ],
    }
  },
  apollo: {
    institutions: {
      query: ALL_CUSTOMERS,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          searchKeyword: this.searchKeyword
        }
      }
    }
  },
  computed: {
    ... mapGetters({
      httpLoading: 'http/httpLoading',
      httpErrors: 'http/httpErrors'
    })
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    ... mapActions({
      updateCustomerFn: 'customers/updateCustomer',
      generateCustomersReport: 'http/generateCustomersReport',
    }),
    viewCustomerDetails(public_id){
      this.$router.push(routeItems.single_customer_route+'/'+public_id)
    },
    selectCustomer(row){
      this.selected_customer = row
    },
    async updateCustomer(data){
      data.id = this.selected_customer.publicId
      await this.updateCustomerFn(data).then(resp => {
        if(resp.publicId){
          successToast(`${resp.name} updated successfully`)
        }

      })
    },
    searchFn(data){
      this.searchKeyword = data
    },
    async downloadCustomersReport(){
      const response = await this.generateCustomersReport()
      if(response.data.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
        const today = moment().format('YYYY-MM-DD')
        downloadFileConfig(response, `Customers Report on ${today}.xlsx`)
      }else {
        errorToast('Error generating customers report')
      }
    }
  },
  watch: {
    currentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style scoped>

</style>
